import React, { Component } from 'react';
import LoginApi from '../../../pages/login/login.api';
import AutorizacaoLaudarPage from './autorizacao-laudar.page';

class AutorizacaoLaudarContainer extends Component {
    constructor() {
        super();
        this.state = {
            usuario_valido: true,
            senha_valido: true
        }
    }

    render() {
        return <AutorizacaoLaudarPage
            onChange={this.onChange.bind(this)}
            loginAutorizar={this.loginAutorizar.bind(this)}
            usuario_valido={this.state.usuario_valido}
            senha_valido={this.state.senha_valido}
            fecharTela={this.props.fecharTela}
        />
    }

    loginAutorizar() {
        const { usuario, senha } = this.state;

        if (usuario !== '' && senha !== '') {
            LoginApi.logar(usuario, senha).then(user => {
                if (user.status === 200) {
                    this.setState({ usuario_valido: true, senha_valido: true });
                    if (user.data.medicoId && !user.data.isResidente) {
                        this.props.callback.sucesso(user.data.medicoId);
                    } else {
                        this.props.callback.error();
                    }
                } else {
                    user.data.forEach(item => {
                        const atb = `${item.property}_valido`;
                        this.setState({ [atb]: false})
                    });
                }

            }).catch((error) => {
                this.setState({ usuario_valido: false, senha_valido: false });
            });
        }
        else {
            this.setState({ usuario_valido: false, senha_valido: false });
        }
    }

    onChange(event) {
        const atb = `${event.target.name}_valido`;
        this.setState({
            [event.target.name]: event.target.value,
            [atb]: true,
        });
    }

}


export default AutorizacaoLaudarContainer;


// WEBPACK FOOTER //
// ./src/app/common/autorizacaoLaudar/autorizacao-laudar.container.js